import React from 'react';
import Tooltip from '@material-ui/core/Tooltip';
import IconButton from '@material-ui/core/IconButton';
import ReceiptIcon from '@material-ui/icons/Receipt';
import AppToast from '../../ui/AppToast';
import Api from '../../helpers/Api';
import Env from '../../config/env';

class GenerateDuplicateInvoice extends React.Component {
  handleOpenInvoice = async (account) => {
    const cuentaCompleta = Number(account.cuentaCodigo);
    const cuenta = Math.floor(cuentaCompleta / 1000);
    const digitos = cuentaCompleta % 1000;
    const secuencia = parseInt(Math.random() * (99999 - 1000) + 1000);

    const params = {
      cycle: account.CICLO,
      month: account.MES,
      year: account.ANO,
      account: cuenta,
      digits: digitos,
      sequence: secuencia,
    };
    const data = await Api.post(`${Env.UrlBackend}/get-invoice`, params);
    if (data.success) {
      const popUp = window.open(Env.UrlFilesPublic + data.path);
      if (popUp == null || typeof popUp == 'undefined') {
        AppToast(<span>Debes habilitar las ventanas emergentes para visualizar la factura.</span>);
      }
    }
  };

  render() {
    const { account } = this.props;

    return (
      <div>
        <Tooltip
          title="Generar duplicado factura"
          onClick={() => {
            this.handleOpenInvoice(account);
          }}
        >
          <IconButton color="secondary">
            <ReceiptIcon fontSize="large" />
          </IconButton>
        </Tooltip>
        <span
          style={{
            fontSize: '11px',
            fontStyle: 'italic',
            display: 'block',
          }}
        >
          Copia factura
        </span>
      </div>
    );
  }
}

export default GenerateDuplicateInvoice;
